<template>
    <pane-view :tools="tools" previewPaneClass="pane-width-800">
        <template slot="search-pane">
            <pane-header title="Search and filter" :tools="tools" :hasCloseSearchIcon="true" />
            <ui-scrollable-container>
                <pane-content>
                    <ui-search-field class="pane__search-bar" :tools="tools" />
                    <ui-checklist
                        title="Status"
                        :items="['Active', 'Inactive']"
                    />
                    <ui-checklist
                        title="Patron Group"
                        :items="patronGroups"
                    />
                </pane-content>
            </ui-scrollable-container>
        </template>
        <template slot="results-pane">
            <pane-header title="Users" subtitle="209 search results" :hasSearchIcon="true" :tools="tools" appIconKey="user">
                <ui-button slot="right" title="New" iconLeft="plus" />
            </pane-header>
            <ui-scrollable-container>
                <pane-content>
                    <ui-data-list
                        preset="user"
                        type="results"
                        :tools="tools"
                        :itemCount="106"
                    />
                </pane-content>
            </ui-scrollable-container>
        </template>
        <template slot="preview-pane">
            <pane-preview-container
                :tools="tools"
            />
        </template>
    </pane-view>
</template>

<script>
    import PaneView from './PaneView';
    import dummyData from '../../dummy/dummy-data';

    export default {
        name: 'users-view',
        props: ['tools'],
        components: {
            PaneView,
        },
        computed: {
            patronGroups() {
                return dummyData('patron_groups');
            },
        },
    }
</script>



// WEBPACK FOOTER //
// UsersView.vue?22a09e5c